export default "__VITE_ASSET__BzzVj0SV__"